import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import ImageList from '@/components/Layouts/ImageList'
import Button from '@mui/material/Button'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface ButtonData {
    text?: string
    link?: string
}

interface ImageItem {
    src: string
    alt?: string
    srcSet?: string
    sizes?: string
}

interface Content {
    title?: string
    text?: string
    button?: ButtonData
    images?: ImageItem[]
}

interface S1_Hero_4Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_Hero_4Props) => {
    const { content = {} } = props
    const { title, text, button = {}, images } = content
    const normalizedImages: ImageItem[] = (images || [])
        .map((img) => {
            const imageData = getImageData(img)
            return {
                src: imageData.src,
                alt: imageData.alt,
                srcSet: imageData.srcSet,
                sizes: imageData.sizes,
            }
        })
        .filter((img) => Boolean(img.src))
    return (
        <RegularSection aria-label='S1_Hero_4' >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
                <ColorTitle
                    title={title}
                    colorFrom={0}
                    textAlign='start'
                />

                <Typography variant='body2'>{text}</Typography>
                <Button
                    variant='contained'
                    color='primary'
                    href={button.link || '#'}
                    size='large'
                    sx={{ width: { xs: '100%', md: 'fit-content' } }}
                    aria-label='Learn more about projects'
                >
                    {'Learn more about projects'}
                </Button>
            </Box>

            <ImageList images={normalizedImages}/>
        </RegularSection>
    )
}

export default Index
